// @flow

// Name
export const MODEL = 'seasonJobs'

// Api End Point
export const URL = 'hefty/soilsimport'

// State Configuration
export const TREE = 'soilJobsModule'
export const BRANCH = 'importJobsOperations'

// Model Properties
export const PROP_ID = 'id'
export const PROP_SEASON_ID = PROP_ID
export const PROP_FILES = 'files'
export const PROP_WARNINGS = 'warnings'

// Options
export const MAX_FILES_COUNT = 1
export const FILE_EXTENSION = 'zip'

// Request parameters
export const PARAM_SEASON = 'season'
export const PARAM_FILE = 'file'
